import CallflowEdge from './CallflowEdge';

import type { EdgeTypes } from '@xyflow/react';

const edgeTypes: EdgeTypes = {
  default: CallflowEdge,
};

export default edgeTypes;
